import { all, fork } from "redux-saga/effects";
import apiHandler from "./apiHandler";

const rootSaga = function* () {
  yield all([
    fork(apiHandler),
  ]);
};

export default rootSaga;
